import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-off-duty-codes',
  templateUrl: './off-duty-codes.component.html',
  styleUrls: ['./off-duty-codes.component.css']
})
export class OffDutyCodesComponent implements OnInit {
    public itemsListOffDutyCodes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadOffDutyCodes(): Promise<void> {
        this.itemsListOffDutyCodes = await this.datatask.Post(488);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'offdutycode':
                this.stateService?.go('offdutycode', { offdutycode_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadOffDutyCodes();
    }

    ngOnInit() {
        this.init();
    }
}
